import React from 'react';
import { connect } from 'react-redux';

import {
  currentUserId as getCurrentUserId,
  accessToken as getAccessToken,
} from '@core/selectors/user';
import { getMaterialPlacementLtiProviders } from '@core/selectors/lti';
import { isInstructor, currentClassRoomId } from '@core/selectors/classroom';
import { CommentEntityType } from '@core/utils/commentsEntityTypes';
import AulaEditorWithAnalytics from '../../../../common/AulaEditor/AulaEditorWithAnalytics';
import AulaEditorWithAnalyticsWithoutPlugins from '../../../../common/AulaEditor/AulaEditorWithAnalyticsWithoutPlugins';
import EditCommentModal from './EditCommentModal';
import { Comment } from '../../../../Comments/types';

interface OwnProps {
  open: boolean;
  onClose: () => void;
  comment: Comment;
  entityType: CommentEntityType;
  entityId: string;
}

const mapStateToProps = (state: any) => {
  const currentUserId = getCurrentUserId(state);
  const spaceId = currentClassRoomId(state);
  const isEducator = isInstructor(state, currentUserId);

  return {
    spaceId,
    isEducator,
    accessToken: getAccessToken(state, spaceId),
    institution: state.institution.general.institution,
    ltiProviders: getMaterialPlacementLtiProviders(state),
    EditorComponent: isEducator
      ? AulaEditorWithAnalytics
      : AulaEditorWithAnalyticsWithoutPlugins,
  };
};

const EditCommentModalContainer = connect<any, never, OwnProps>(
  mapStateToProps
)(EditCommentModal);

export default EditCommentModalContainer as React.ComponentType<OwnProps>;
